<template>
    <svg>
        <use :xlink:href="`${contextPath}${sprite}#${name}`" style="pointer-events: none"></use>
    </svg>
</template>

<script lang="ts" setup>
import { withDefaults, defineProps, computed, inject } from 'vue';

const props = withDefaults(defineProps<{
    name: string;
    source?: string;
}>(), {
    source: '/img/sprite.svg'
});
const prototype = inject('prototype');
const contextPath = inject('contextPath');

const sprite = computed(() => (prototype ? '' : '/.resources/rize/webresources') + props.source);
</script>
